import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-married-filing',
  templateUrl: './married-filing.component.html',
  styleUrls: ['./married-filing.component.scss']
})
export class MarriedFilingComponent {
  @Output() action: EventEmitter<void>;

  constructor() { 
    this.action = new EventEmitter<void>();
  }

  submit(): void {
    this.action.next();
  }

}
